<div class="page-container">
  <app-header></app-header>

  <main class="page-content" #pageContent>
    <section class="page-hero">
      <div class="page-hero-content">
        <h1 class="page-title">About Markado</h1>
        <p class="page-subtitle">Connecting the world through commerce</p>
        <div class="hero-divider"></div>
      </div>
    </section>

    <div class="page-layout">
      <aside class="page-sidebar">
        <div class="sidebar-content">
          <h2 class="sidebar-title">Navigate</h2>
          <ul class="sidebar-nav">
            <li *ngFor="let section of sections">
              <a
                (click)="scrollToSection(section.id)"
                class="sidebar-link"
                [class.active]="isActive(section.id)"
                [attr.aria-current]="isActive(section.id) ? 'true' : null"
              >
                {{ section.title }}
              </a>
            </li>
          </ul>
        </div>
      </aside>

      <div class="page-main">
        <div class="page-sections">
          <section
            *ngFor="let section of sections; trackBy: trackBySection"
            class="page-section"
            [id]="section.id"
            [attr.aria-labelledby]="section.id + '-title'"
          >
            <h2 class="section-title" [id]="section.id + '-title'">
              {{ section.title }}
            </h2>
            <div class="section-content" [innerHTML]="section.content"></div>
          </section>
        </div>
      </div>
    </div>
  </main>

  <app-footer></app-footer>
</div>
